import { render, staticRenderFns } from "./PwaPrompt.vue?vue&type=template&id=3c3e9c10"
import script from "./PwaPrompt.vue?vue&type=script&lang=ts"
export * from "./PwaPrompt.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports